import create from 'zustand';

export const [useSlideshowStore, slideshowApi] = create(set => ({
  activeSlide: 0,

  setActiveSlide: id => {
    set({ activeSlide: id });
  },
}));
